async function sendVisitorInfo() {
  const baseUrl = window.location.origin;
  await fetch(`${baseUrl}/secret/api/stats`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      screen: `${screen.width}x${screen.height}`,
      lang: navigator.language,
    }),
    credentials: "include",
  });
}

// Direkt beim Laden senden
document.addEventListener("DOMContentLoaded", sendVisitorInfo);
